import { Fragment } from 'react';
import { Options, Item } from './styled';

const RadioGroup = ({
  field,
  label,
  onChange,
  value,
  options = [],
}) => (
  <Options>
    <em>
      {label}
      &nbsp;&nbsp;
    </em>
    <span>
      {options.map((option, index) => (
        <Fragment key={option.value}>
          {index !== 0 ? '  /  ' : null}
          <Item
            isActive={value === option.value}
            onClick={() => onChange(
              field,
              option.value,
            )}
          >
            {option.label}
          </Item>
        </Fragment>
      ))}
    </span>
  </Options>
);
export default RadioGroup;
